export type SessionUser = {
  id: string;
  email: string;
  roles: string[];
  permissions: string[];
};

export function isSessionUser(value: unknown): value is SessionUser {
  if (!value || typeof value !== 'object') return false;
  const record = value as Record<string, unknown>;
  return typeof record.id === 'string'
    && typeof record.email === 'string'
    && Array.isArray(record.roles)
    && record.roles.every((item) => typeof item === 'string')
    && Array.isArray(record.permissions)
    && record.permissions.every((item) => typeof item === 'string');
}

export async function fetchSession(): Promise<SessionUser | null> {
  const res = await fetch('/auth/me');
  if (!res.ok) return null;
  let data: unknown;
  try {
    data = await res.json();
  } catch (error) {
    if (error instanceof SyntaxError) return null;
    throw error;
  }
  return isSessionUser(data) ? data : null;
}

export function hasPermission(session: SessionUser | null, permission: string): boolean {
  return !!session?.permissions.includes(permission);
}
